export default "__VITE_PUBLIC_ASSET__257fc1de__"